// Transitions
export const AHOC_FORM_VALID_TRANSITION_BASIC_DETAILS =
  "allsureHomeClaim/basicDetails/transition/formValid";
export const AHOC_FORM_INVALID_TRANSITION_BASIC_DETAILS =
  "allsureHomeClaim/basicDetails/transition/formInvalid";

export const AHOC_RESET_STATE_TRANSITION_BASIC_DETAILS =
  "allsureHomeClaim/basicDetails/transition/resetState";

export const AHOC_BASIC_DETAILS =
  "allsureHomeClaim/basicDetails/";
export const AHOC_BASIC_DETAILS_SET_VALUE =
AHOC_BASIC_DETAILS+"setValue/";
export const AHOC_BASIC_DETAILS_SET_VALID =
AHOC_BASIC_DETAILS +"setValid/";
export const PURCHASE_PERSONAL_DETAILS_EDIT =
AHOC_BASIC_DETAILS +"setEdit";


//action

export const transitionBasicDetails = {
  formValid: () => ({ type: AHOC_FORM_VALID_TRANSITION_BASIC_DETAILS }),
  formInvalid: () => ({ type: AHOC_FORM_INVALID_TRANSITION_BASIC_DETAILS }),
};

export const resetPurchasePersonalDetails = () => ({
  type: AHOC_RESET_STATE_TRANSITION_BASIC_DETAILS,
});

export const setBasicDetailsFieldValue =(value)=>({type: AHOC_BASIC_DETAILS_SET_VALUE, value})
export const setBasicDetailsFieldValid =(error,fieldType)=>({type: AHOC_BASIC_DETAILS_SET_VALID, error, fieldType})
export const setPurchasePersonalDetailsEdit =(value)=>({type: PURCHASE_PERSONAL_DETAILS_EDIT, value})


export const AHOC_BASIC_DETAILS_SET_VALUE_WITHOUT_VALIDATION =
AHOC_BASIC_DETAILS+"withoutValiddation/setValue";
export const setAhocBasicDetailsWithoutValidation =(value)=>({type: AHOC_BASIC_DETAILS_SET_VALUE_WITHOUT_VALIDATION, value})
